export default function getDefaultValues(type) {
	return Object.entries(type.shape).reduce((acc, [key, value]) => {
		return {
			...acc,
			[key]: getDefaultValue(value),
		};
	}, {});
}

function getDefaultValue(value) {
	if (value._def.defaultValue !== undefined) {
		return value._def.defaultValue();
	}

	return undefined;
}
